// directives/dialogDrag.js
export default {
  bind(el, binding, vnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')

    if (!dialogHeaderEl || !dragDom) return

    dialogHeaderEl.style.cursor = 'move'
    dialogHeaderEl.onselectstart = () => false

    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)

    dialogHeaderEl.onmousedown = (e) => {
      // 如果是最小化或全屏状态，禁止拖拽
      const isMinimize = el.classList.contains('is-minimize')
      const isFullscreen = el.classList.contains('is-fullscreen')
      if (isMinimize || isFullscreen) return

      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      let styL, styT
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
      } else {
        styL = +sty.left.replace('px', '')
        styT = +sty.top.replace('px', '')
      }

      document.onmousemove = function (e) {
        const l = e.clientX - disX
        const t = e.clientY - disY

        dragDom.style.left = `${l + styL}px`
        dragDom.style.top = `${t + styT}px`
      }

      document.onmouseup = function () {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}
